<template>
    <div 
        id="ariane"
        v-if="!okanMain.fromURL"
    >    

    <div 
        v-for="(button, buttonIndex) in okanMain.buttons"
        v-bind:key="buttonIndex"
        class="arianeItem"
        v-bind:class="[{'disabled' : buttonIndex > okanMain.arianeLevel}, {'selected' : buttonIndex == okanMain.arianeLevel}]"
        @click="switchLevel(buttonIndex)"
    >
        {{button}}
    </div>

    </div>

</template>

<script>



export default {
  name: 'Ariane',
  components: {

  },
  props: {
      okanMain : Object,
  },
  data() {
    return {
        buttons : [ "Quartier", "Bâtiment", "Appartement"], //"Quartier",
    }
  },
  methods: {
    switchLevel(buttonIndex){
        if(buttonIndex < this.okanMain.arianeLevel){
            this.okanMain.downGradeArianeLevel(buttonIndex)
        }
    },
    getTitle(){
        if(this.okanMain == null || this.okanMain.params == null ){
            console.log('here', this.okanMain.params);
            setTimeout(() => {
                this.getTitle();
            }, 150);
        }else{
            this.buttons[0] = this.okanMain.params.title;   
        }
    },
    getButtons(){
        if(this.okanMain.selectedBatiment != null){
            this.buttons[1] = this.okanMain.params.batiments[this.okanMain.selectedBatiment].title;
        }
        return this.buttons;
    }
  },
  mounted() {
      setTimeout(() => {
          this.getTitle();
      }, 500);
      

  }
}
</script>

<style src="../assets/css/ariane.css"></style>